import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodColumn from "./AbstractPeriodColumn.js";

/**
 * Year to date report column.
 */
class YearToDateColumn extends AbstractPeriodColumn {
	accept(visitor) {
		return visitor.visitYearToDateColumn(this);
	}

	_getDefaultTitle() {
		return _("YTD {period}", {
			period: super._getDefaultTitle(),
		});
	}

	_operation() {
		return "yearToDate";
	}

	static getType() {
		return "YearToDateColumn";
	}
}

export default YearToDateColumn;
